"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToPrecision = void 0;
function roundToPrecision(number, precision) {
    if (precision === void 0) { precision = 2; }
    return (function (factor) { return Math.round(number * factor) / factor; })(Math.pow(10, precision));
}
exports.roundToPrecision = roundToPrecision;
//# sourceMappingURL=generic.js.map